var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsisVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 13,
    viewBox: "0 0 4 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.59375C2.54688 9.59375 3.03906 9.89453 3.3125 10.3594C3.58594 10.8516 3.58594 11.4258 3.3125 11.8906C3.03906 12.3828 2.54688 12.6562 2 12.6562C1.42578 12.6562 0.933594 12.3828 0.660156 11.8906C0.386719 11.4258 0.386719 10.8516 0.660156 10.3594C0.933594 9.89453 1.42578 9.59375 2 9.59375ZM2 5.21875C2.54688 5.21875 3.03906 5.51953 3.3125 5.98438C3.58594 6.47656 3.58594 7.05078 3.3125 7.51562C3.03906 8.00781 2.54688 8.28125 2 8.28125C1.42578 8.28125 0.933594 8.00781 0.660156 7.51562C0.386719 7.05078 0.386719 6.47656 0.660156 5.98438C0.933594 5.51953 1.42578 5.21875 2 5.21875ZM3.53125 2.375C3.53125 2.94922 3.23047 3.44141 2.76562 3.71484C2.27344 3.98828 1.69922 3.98828 1.23438 3.71484C0.742188 3.44141 0.46875 2.94922 0.46875 2.375C0.46875 1.82812 0.742188 1.33594 1.23438 1.0625C1.69922 0.789062 2.27344 0.789062 2.76562 1.0625C3.23047 1.33594 3.53125 1.82812 3.53125 2.375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisVertical);
export default __webpack_public_path__ + "static/media/ellipsis_vertical.0b8e36be114556edf20223f1bdef5e27.svg";
export { ForwardRef as ReactComponent };